import { Repeat2 } from "lucide-react";

type RecurrenceBadgeProps = {
  meeting: {
    recurrence_id?: string | null;
    recurrence_index?: number | null;
    recurrence_total?: number | null;
  };
};

export default function RecurrenceBadge({ meeting }: RecurrenceBadgeProps) {
  if (!meeting.recurrence_id) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-azul-400/10 px-2 py-0.5 text-[10px] font-medium text-azul-400"
      title="Este compromisso faz parte de uma série semanal"
    >
      <Repeat2 size={11} aria-hidden="true" />
      {meeting.recurrence_total
        ? `Recorrente ${meeting.recurrence_index}/${meeting.recurrence_total}`
        : "Recorrente"}
    </span>
  );
}
